import { z } from "zod";

export const certificationSchema = z.object({
  Name: z.string(),
  Url: z.string().optional(),
  Authority: z.string(),
  "Started On": z.string().optional(),
  "Finished On": z.string().optional(),
  "License Number": z.string().optional(),
});
